export const defaultItemDetailTab = ({
  isFinancialProjection,
  hasPrevision,
}) => {
  if (!isFinancialProjection) return "resources";
  return hasPrevision ? "plannedMeasured" : "creditors";
};
